export default "__VITE_ASSET__BJ_tO$A1__"